/*** IMPORTS FROM imports-loader ***/
var define = false;

import { __extends } from "tslib";
import { ApolloLink } from "../core/index.js";
import { createHttpLink } from "./createHttpLink.js";
var HttpLink = (function (_super) {
    __extends(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, createHttpLink(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}(ApolloLink));
export { HttpLink };
//# sourceMappingURL=HttpLink.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/link/http/HttpLink.js
// module id = 1558
// module chunks = 0